export const CodeMergerInfos = [
  ...['json', 'yaml', 'toml'].map(lang => ({
    key: `${lang}-merger`,
    category: 'merge',
    group: lang,
    url: `/${lang}-merger`,
    isPrivate: false,
  }))
]
